import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { CtaSectionComponent } from '@app/widgets';
import { IOS_CERTIFICATE_GENERATOR_FAQS } from '../../constants';
import { IosCertificateGeneratorFaqSectionComponent } from '../ios-certificate-generator-faq-section/ios-certificate-generator-faq-section.component';
import { IosCertificateGeneratorFormSectionComponent } from '../ios-certificate-generator-form-section/ios-certificate-generator-form-section.component';
import { IosCertificateGeneratorInfoSectionComponent } from '../ios-certificate-generator-info-section/ios-certificate-generator-info-section.component';

@Component({
  selector: 'app-ios-certificate-generator',
  imports: [
    IosCertificateGeneratorFormSectionComponent,
    IosCertificateGeneratorInfoSectionComponent,
    IosCertificateGeneratorFaqSectionComponent,
    CtaSectionComponent,
  ],
  templateUrl: './ios-certificate-generator.component.html',
  styleUrl: './ios-certificate-generator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosCertificateGeneratorComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setTitle('iOS Certificate Generator');
    this.metaService.setDescription(
      'Generate an iOS certificate signing request and convert your .cer to .p12 directly in your browser. No data is sent to any server.',
    );
    this.metaService.setKeywords([
      'iOS certificate generator',
      'generate iOS certificate online',
      'CSR generator',
      'convert cer to p12',
      'iOS app signing',
      'iOS signing certificate',
      'certificate signing request',
      'Capacitor iOS signing',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'iOS Certificate Generator',
        'Generate an iOS certificate signing request and convert your .cer to .p12 directly in your browser.',
        'https://cloud.capawesome.io/tools/ios-certificate-generator/',
      ),
      JsonLdService.buildFaqSchema(IOS_CERTIFICATE_GENERATOR_FAQS),
      JsonLdService.buildHowToSchema(
        'How to Generate an iOS Signing Certificate',
        'Generate a CSR and convert your Apple-issued .cer to a .p12 bundle directly in your browser.',
        [
          {
            name: 'Generate a CSR',
            text: 'Fill in your details and generate a Certificate Signing Request in your browser.',
          },
          {
            name: 'Upload to Apple Developer Portal',
            text: 'Upload the CSR to Apple Developer Portal and download the signed .cer file.',
          },
          {
            name: 'Download your .p12 bundle',
            text: 'Upload the .cer file back to this tool and download your .p12 certificate bundle.',
          },
        ],
      ),
    ]);
  }
}
